// extracted by mini-css-extract-plugin
export default {"formFields":"AdminSecurityView-module__formFields--dcfMv","formFooter":"AdminSecurityView-module__formFooter--l0083"};